import { render, staticRenderFns } from "./Leave2.vue?vue&type=template&id=1bedd6c2"
import script from "./Leave2.vue?vue&type=script&lang=js"
export * from "./Leave2.vue?vue&type=script&lang=js"
import style0 from "./Leave2.vue?vue&type=style&index=0&id=1bedd6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports